import { useEffect, useState } from 'react';

// Hash-Router: funktioniert auf jedem Webspace ohne Rewrite-Regeln für die App selbst.

export function aktuellerPfad(): string[] {
  return window.location.hash
    .replace(/^#\/?/, '')
    .split('/')
    .filter(Boolean)
    .map(decodeURIComponent);
}

export function useRoute(): string[] {
  const [pfad, setPfad] = useState(aktuellerPfad);
  useEffect(() => {
    const f = () => setPfad(aktuellerPfad());
    window.addEventListener('hashchange', f);
    return () => window.removeEventListener('hashchange', f);
  }, []);
  return pfad;
}

export function gehe(pfad: string): void {
  window.location.hash = pfad.startsWith('#') ? pfad : `#${pfad}`;
}

export function link(...teile: string[]): string {
  return '#/' + teile.map(encodeURIComponent).join('/');
}
